/* eslint-disable max-len */
/**
 * Image Data Transformer
 * Transforms the nested API response structure to the flat structure expected by ImageDetailsSlider
 */

export const transformImageDataForSlider = (contentData: any) =>
{
	if (!contentData || !contentData.files || !contentData.files[0])
	{
		return null;
	}

	const image = contentData.files[0];

	return {
		// From files[0] - image specific data
		id          : contentData._id,
		title       : image.title || '',
		description : image.description || '',
		url         : image.url || '',
		thumbnail   : image.thumbnail || null,
		status      : image.status?.toLowerCase() || '',
		fileType    : image.fileType || '',
		fileSize    : image.fileSize || 0,
		dimensions  : image.dimensions || {},

		// From files[0] - image access control (different from videos - file-level)
		visibility    : image.visibility?.toLowerCase() || '',
		allowDownload : image.allowDownload ?? false,
		allowShare    : image.allowShare ?? false,
		accessControl : image.accessControl || {},
		categoryIds   : image.categoryIds || [],

		// From top level - collection data
		tags : contentData.tags || [],

		// Additional metadata
		engagement      : contentData.engagement || {},
		createdBy       : contentData.createdBy || {},
		imageCreatedAt  : contentData.imageCreatedAt,
		imageUpdatedAt  : contentData.imageUpdatedAt,
		publishedBy     : contentData.publishedBy || null,
		publishedAt     : contentData.publishedAt || null,
		scheduledPublishDate : contentData.scheduledPublishDate || null,

		// Keep original for reference
		originalData : contentData
	};
}; 